import { Checkbox as MuiCheckbox } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';
import { getReccurssiveObjectKeys } from '../../utils';

export const Checkbox = ({ name, sx, fontSize, ...props }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      render={({ field, formState: { errors } }) => (
        <MuiCheckbox
          error={!!getReccurssiveObjectKeys(errors, name)}
          checked={field.value || false}
          {...field}
          {...props}
          sx={{
            ...sx,
            '& .MuiSvgIcon-root': { fontSize: fontSize || 26 }
          }}
        />
      )}
    />
  );
};
